// "Spot the Slip" expansion — FAMILY theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_FAMILY = [
  ["Mio padre sta in pensione e molto felice.", "Mio padre è in pensione ed è molto felice.", "essere-stare",
    "'Essere in pensione' uses essere → è in pensione.", "essere-vs-stare"],
  ["I miei genitori stanno divorziati dal 2019.", "I miei genitori sono divorziati dal 2019.", "essere-stare",
    "A resulting marital state uses essere → sono divorziati.", "essere-vs-stare"],
  ["Il matrimonio è nella chiesa del paese.", "Il matrimonio è nella chiesa del paese.", "essere-stare",
    "Trap check: an event 'taking place' uses essere. (Already correct!)", "essere-vs-stare"],
  ["Ho un cugina molto sveglia.", "Ho una cugina molto sveglia.", "gender",
    "Cugina is feminine → una cugina.", "gender-of-nouns"],
  ["Mia cugina è alto e magro.", "Mia cugina è alta e magra.", "agreement",
    "Feminine subject → alta e magra.", "adjective-agreement"],
  ["I genitori di Maria sono molto unito.", "I genitori di Maria sono molto uniti.", "agreement",
    "Masculine plural subject → uniti.", "adjective-agreement"],
  ["Mi piace i miei cugini del Cile.", "Mi piacciono i miei cugini del Cile.", "piacere",
    "The verb agrees with the thing liked; plural cousins → piacciono.", "piacere-and-similar-verbs"],
  ["Ai miei fratelli piace le domeniche in famiglia.", "Ai miei fratelli piacciono le domeniche in famiglia.", "piacere",
    "Plural Sundays → piacciono.", "piacere-and-similar-verbs"],
  ["Vado da i nonni domenica.", "Vado dai nonni domenica.", "articulated-prep",
    "da + i contracts to dai.", "preposition-contractions"],
  ["La casa di la nonna è in campagna.", "La casa della nonna è in campagna.", "articulated-prep",
    "di + la contracts to della.", "preposition-contractions"],
  ["Quando eravamo bambini, siamo andati dalla nonna ogni estate.", "Quando eravamo bambini, andavamo dalla nonna ogni estate.", "passato-imperfetto",
    "A repeated childhood habit is imperfetto → andavamo.", "passato-prossimo-vs-imperfetto"],
  ["Il bambino di mia cugina ha nato a marzo.", "Il bambino di mia cugina è nato a marzo.", "auxiliary",
    "Nascere takes essere → è nato.", "compound-tenses-and-auxiliaries"],
  ["Spero che la mia famiglia viene al matrimonio.", "Spero che la mia famiglia venga al matrimonio.", "congiuntivo",
    "Sperare che (hope) flips the verb to the subjunctive → venga.", "congiuntivo-presente"],
  ["Voglio che i miei figli vanno d'accordo.", "Voglio che i miei figli vadano d'accordo.", "congiuntivo",
    "A wish about others (volere che) triggers the subjunctive → vadano.", "congiuntivo-presente"],
  ["Mi piace molto stare con la famiglia.", "Mi piace molto stare con la famiglia.", "piacere",
    "Trap check: an infinitive keeps piacere singular. (Already correct!)", "piacere-and-similar-verbs"],
];
